import { useRegisterAxiosInterceptors } from "./axios"

export default function AxiosInterceptors({ children }: React.PropsWithChildren) {
  const { hasAxiosBeenInitializedOnce } = useRegisterAxiosInterceptors()

  return hasAxiosBeenInitializedOnce ? <>{children}</> : null
}
